<template>
  <div class="page">
    <div class="container pt-4">
      <div class="page-form-row row">
        <div class="card main-card">
          <img class="brand-logo" :src="$store.getters.getLogo || '../assets/logo_tmp.png'" />
          <div v-html="submitResult.Message"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageOutro',
  components: {

  },
  data: () => {
    return {

    }
  },
  computed: {
    submitResult: function () {
      return this.$store.getters.getSubmitResult
    }
  },
  methods: {

  },
  mounted: function() {

  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.container {
  display: flex;
  height: 100vh;
  align-items: center;
}

.card {
  text-align: center;
  padding: 40px 15px;
  font-size: 24px;
}

.brand-logo {
  margin-bottom: 30px;
  width: auto;
  max-height: 80px;
}

.page-form-row {
  line-height: normal;
}
</style>
